import { useQuery } from '@apollo/react-hooks';
import { ApolloClient, gql } from 'apollo-boost';

import { PermissaoSimplificadaType, Query, QueryTodasEntidadesRelayArgs } from 'types/graphql';

const getPermissoesSimplificadasQuery = gql`
  query PermissoesSimplificadasQuery {
    permissoesSimplificadas {
      agrupadoPorDescricao {
        permssaoDescricao
        loja
      }
    }
  }
`;

export function useGetSimplifiedPermissionsQueries() {
  const simplifiedPermissions = useQuery<Pick<Query, 'permissoesSimplificadas'>>(getPermissoesSimplificadasQuery, {
    fetchPolicy: 'cache-first',
  });
  return simplifiedPermissions;
}

export async function getSimplifiedPermissionsPromiseQueries(client: ApolloClient<object>) {
  const simplifiedPermissions = await client.query<Pick<Query, 'permissoesSimplificadas'>>({
    query: getPermissoesSimplificadasQuery,
    fetchPolicy: 'cache-first',
  });
  return simplifiedPermissions;
}

// ----------------------------------------------------------------

const getPermissoesSimplificadasAgrupadoPorLojaQuery = gql`
  query PermissoesSimplificadasAgrupadoPorLojaQuery($idFuncionario: Int) {
    permissoesSimplificadas(idFuncionario: $idFuncionario) {
      agrupadoPorLoja {
        loja
        permssaoDescricao
      }
    }
  }
`;

export function useGetSimplifiedPermissionsPerStoreQueries(idFuncionario?: number) {
  const simplifiedPermissionsPerStore = useQuery<Pick<Query, 'permissoesSimplificadas'>>(
    getPermissoesSimplificadasAgrupadoPorLojaQuery,
    {
      fetchPolicy: 'cache-first',
      variables: { idFuncionario },
    },
  );
  return simplifiedPermissionsPerStore;
}

export async function getSimplifiedPermissionsPerStorePromiseQueries(client: ApolloClient<object>) {
  const simplifiedPermissionsPerStore = await client.query<Pick<Query, 'permissoesSimplificadas'>>({
    query: getPermissoesSimplificadasAgrupadoPorLojaQuery,
    fetchPolicy: 'cache-first',
  });
  return simplifiedPermissionsPerStore;
}

const getAllEntitiesRelayQuery = gql`
  query QueryAllEntitiesRelay($id_In: String) {
    todasEntidadesRelay(id_In: $id_In) {
      edges {
        node {
          id
          pk
          nome
          nomeIdentificacao
          label: nomeIdentificacao
        }
      }
    }
  }
`;

export function useGetAllStoresByIds(skip: boolean, variables: QueryTodasEntidadesRelayArgs) {
  const allStoresQuery = useQuery<Pick<Query, 'todasEntidadesRelay'>, QueryTodasEntidadesRelayArgs>(
    getAllEntitiesRelayQuery,
    { fetchPolicy: 'cache-first', variables, skip },
  );
  return allStoresQuery;
}
